import { render } from "./CadastrarSaidaItens.vue?vue&type=template&id=07db0e2a"
import script from "./CadastrarSaidaItens.vue?vue&type=script&lang=js"
export * from "./CadastrarSaidaItens.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__